import { call } from '../../../../stent/call';
export const makeChangeQuantity = function(ctx) {
    const { changeItemQuantity , afterUpdate  } = ctx;
    return function* changeQuantity(machine, payload) {
        try {
            if (machine.state.contents == null) {
                throw new Error('Cart contents missing');
            }
            yield {
                name: 'Updating',
                error: null,
                contents: machine.state.contents
            };
            yield call(changeItemQuantity, payload);
            yield {
                name: 'Stale',
                error: null,
                contents: machine.state.contents
            };
            machine.refresh();
            afterUpdate();
        } catch (err) {
            yield {
                error: err instanceof Error ? err : new Error('Unknown error [0fb514aefab3448e8d13bef5134ad7ce]'),
                name: 'Failure',
                contents: machine.state.contents
            };
        }
    };
};
